/**
 * 一般廃棄物品目
 */
import Vue from 'vue'
import * as httpConst from '../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/search/general_items`

const search_general_item = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    index () {
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH).then(data => {
          resolve(data.content)
        })
      })
    },
  },
  mutations: {},
}
export default search_general_item
